import { Directive, ElementRef, Input, OnDestroy, OnInit, inject, NgZone } from '@angular/core';

const HIGHLIGHT_CLASS = 'conversation-thread-highlighted';
const THREAD_SELECTOR = 'conversation-message-thread';

@Directive({
  selector: '[conversationThreadHighlight]',
  standalone: false,
})
export class ConversationThreadHighlightDirective implements OnInit, OnDestroy {
  @Input() set conversationThreadHighlight(annotationId: string | null) {
    this._highlightedId = annotationId ?? null;
    this.scheduleUpdate();
  }

  private _highlightedId: string | null = null;
  private readonly el = inject(ElementRef<HTMLElement>);
  private readonly ngZone = inject(NgZone);
  private timeoutId: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    this.scheduleUpdate();
  }

  ngOnDestroy(): void {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.clearAllHighlights();
  }

  private scheduleUpdate(): void {
    if (this.timeoutId != null) {
      clearTimeout(this.timeoutId);
    }
    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = setTimeout(() => {
        this.timeoutId = null;
        this.applyHighlight();
      }, 0);
    });
  }

  private applyHighlight(): void {
    this.clearAllHighlights();
    if (!this._highlightedId) return;
    const thread = this.el.nativeElement.querySelector(
      `${THREAD_SELECTOR}[data-annotation-id="${this._highlightedId}"]`
    ) as HTMLElement | null;
    if (thread) {
      thread.classList.add(HIGHLIGHT_CLASS);
    }
  }

  private clearAllHighlights(): void {
    const threads = this.el.nativeElement.querySelectorAll(`${THREAD_SELECTOR}.${HIGHLIGHT_CLASS}`);
    threads.forEach((el) => el.classList.remove(HIGHLIGHT_CLASS));
  }
}
